export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 3A2.5 2.5 0 0122 5.5v9a2.5 2.5 0 01-2.5 2.5h-5v.5A1.5 1.5 0 0016 19h1v2H7v-2h1a1.5 1.5 0 001.5-1.5V17h-5A2.5 2.5 0 012 14.5v-9A2.5 2.5 0 014.5 3h15zm-15 2a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};